export function getRemoteCastState(): cast.framework.CastState | undefined {
    return cast?.framework?.CastContext?.getInstance().getCastState();
}
